import { useEffect } from "react";
import LText from "@components/LText";
import LBox from "@components/LBox";
import { fonts } from "@theme";
import { router } from "expo-router";
import { trackOnb } from "@components/Onboarding/analytics/trackOnboarding";
import IntroLayout from "@components/Onboarding/Intro/IntroLayout";
import { FadeIn } from "react-native-reanimated";
import { useMe } from "@hooks/trpc/useMe";
import { useOnboardingStore } from "@components/Onboarding/store/onboardingStore";

export default function Aha4() {
  // Accounts can be premium BEFORE their first login (migrated WER1 payers:
  // the import grants the entitlement before the claim email is sent). The
  // paywall is the conversion step for free signups — someone who already
  // pays skips straight to the app.
  const { isPremium } = useMe();
  const clearJourney = useOnboardingStore((s) => s.clearJourney);

  useEffect(() => {
    trackOnb("signup", "aha-4", "view");
  }, []);

  return (
    <IntroLayout
      totalSteps={4}
      currentStep={4}
      buttonLabel="Continue"
      buttonEventName="aha_4"
      onButtonPress={() => {
        if (isPremium) {
          trackOnb("signup", "paywall", "skipped-already-premium");
          clearJourney();
          router.replace("/");
          return;
        }
        router.navigate("/paywall?onboarding=true");
      }}
    >
      <LBox
        flex={1}
        justifyContent="center"
        alignItems="center"
        entering={FadeIn.duration(400).delay(300)}
      >
        <LText
          fontSize={24}
          fontFamily={fonts.semiBold}
          lineHeight={32}
          textAlign="center"
          width="110%"
        >
          {
            "Stream like you\u2019re used to:\n\nLissen ensures your favorite\nartists get their fair share and\nyou get rewarded."
          }
        </LText>
      </LBox>
    </IntroLayout>
  );
}
